var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-wrapper"},[_c('a',{attrs:{"href":"https://github.com/","target":"_blank"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})]),_c('div',{staticClass:"footer-text"},[_vm._v("© All rights reserved, "+_vm._s(_vm.currentYear))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }